import React from 'react';

const OtpIllustration = () => {
  return (
    <div className="w-full h-full flex items-center justify-center p-8">
      <svg
        viewBox="0 0 800 600"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-auto max-w-[650px] drop-shadow-2xl"
      >
        <defs>
          <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="4" />
            <feOffset dx="0" dy="4" result="offsetblur" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.1" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>

          <linearGradient id="bgGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#E5FAFF" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
          </linearGradient>

          <linearGradient id="phoneScreen" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="100%" stopColor="#F8FAFC" />
          </linearGradient>

          <linearGradient id="shieldGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#10B981" />
            <stop offset="100%" stopColor="#059669" />
          </linearGradient>
          
          <pattern id="dots" width="20" height="20" patternUnits="userSpaceOnUse">
             <circle cx="2" cy="2" r="1" fill="#E2E8F0" />
          </pattern>
        </defs>

        {/* Background Elements */}
        <circle cx="400" cy="300" r="280" fill="url(#bgGrad)" />
        <rect x="0" y="0" width="800" height="600" fill="url(#dots)" opacity="0.6" />

        {/* Smartphone Device */}
        <g transform="translate(280, 100)" filter="url(#softShadow)">
            <rect x="0" y="0" width="240" height="420" rx="30" fill="#1E293B" /> {/* Phone Frame */}
            <rect x="10" y="10" width="220" height="400" rx="20" fill="url(#phoneScreen)" /> {/* Screen */}
            
            {/* Notch */}
            <path d="M70 10H170V30C170 35.5228 165.523 40 160 40H80C74.4772 40 70 35.5228 70 30V10Z" fill="#1E293B" />
            
            {/* Screen Content: Message Bubble */}
            <rect x="30" y="100" width="180" height="60" rx="12" fill="#EFF6FF" stroke="#E2E8F0" />
            <text x="45" y="125" fill="#64748B" fontSize="12" fontFamily="sans-serif">Verification Code:</text>
            <text x="45" y="145" fill="#1E4387" fontSize="18" fontWeight="bold" fontFamily="monospace">8 2 9 4</text>
            
            {/* Input Dots */}
            <g transform="translate(50, 200)">
                 <circle cx="15" cy="15" r="8" fill="#E2E8F0" />
                 <circle cx="50" cy="15" r="8" fill="#E2E8F0" />
                 <circle cx="85" cy="15" r="8" fill="#E2E8F0" />
                 <circle cx="120" cy="15" r="8" fill="#E2E8F0" />
                 
                 <circle cx="15" cy="15" r="4" fill="#1E4387" />
                 <circle cx="50" cy="15" r="4" fill="#1E4387" />
            </g>
            
            {/* Keypad simulation */}
             <g transform="translate(40, 260)">
                {[0, 1, 2].map(row => 
                    [0, 1, 2].map(col => (
                        <circle key={`${row}-${col}`} cx={25 + col * 55} cy={20 + row * 40} r="15" fill="#F1F5F9" />
                    ))
                )}
                <circle cx="80" cy="140" r="15" fill="#F1F5F9" />
             </g>
        </g>

        {/* Floating Shield (Security) */}
        <g transform="translate(550, 180)" filter="url(#softShadow)">
            <path d="M0 20C0 8.9543 8.9543 0 20 0H80C91.0457 0 100 8.9543 100 20V40C100 75 70 95 50 100C30 95 0 75 0 40V20Z" fill="url(#shieldGrad)" />
            <path d="M30 45L45 60L70 35" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </g>

        {/* Floating Notification/Message Bubble */}
        <g transform="translate(140, 250) rotate(-5)" filter="url(#softShadow)">
            <rect width="140" height="50" rx="25" fill="white" />
            <circle cx="25" cy="25" r="15" fill="#EFF6FF" />
            <path d="M25 18L32 25L25 32M18 25H32" stroke="#0BAFD4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="50" y="15" width="60" height="8" rx="4" fill="#E2E8F0" />
            <rect x="50" y="30" width="40" height="6" rx="3" fill="#CBD5E1" />
        </g>

        {/* Connecting Signal Waves */}
        <path d="M500 150 Q 550 100 600 120" stroke="#0BAFD4" strokeWidth="2" strokeDasharray="6 6" fill="none" opacity="0.4" />
        <circle cx="600" cy="120" r="4" fill="#0BAFD4" />

        <g transform="translate(240, 420)">
            <path d="M0 0 Q -30 20 -10 50" stroke="#10B981" strokeWidth="2" strokeDasharray="6 6" fill="none" opacity="0.4" />
            <circle cx="-10" cy="50" r="4" fill="#10B981" />
        </g>

      </svg>
    </div>
  );
};

export default OtpIllustration;
